<template>
  <!-- <div id="app"> -->
    <MainLayout>
      <transition 
        name="slide" 
        :appear="isAnimated"
      >
        <slot />
      </transition>      
    </MainLayout>
  <!-- </div> -->
</template>

<script>
import MainLayout from "@/layouts/MainLayout";
export default {
  name: "App",
  components: { 
    MainLayout 
  },
  created() {
    this.$store.dispatch("init");
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/app";

.slide-enter-active {
  transition: all 0.6s ease-in;
}
.slide-enter {
  opacity: 0;
  transform: translateX(100%);
}
</style>